import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { prepareData } from 'helpers/prepare-req-data'
import { prepParams } from 'helpers/prep-req-url'
import { getRespData  } from 'helpers/get-resp-data'
import client from 'api'
import _ from 'lodash'

import { v4 as uuid4 } from 'uuid'


const initialState = {
    startReport206202VSkAbstimmungStatus: 'idle',
    startReport206202VSkAbstimmungError: undefined as any,
    loadUserParamsReport206202VSkAbstimmungStatus: 'idle',
    loadUserParamsReport206202VSkAbstimmungError: undefined as any,

    report206202VSkAbstimmungList: [] as any[],
    defaultValues: undefined as any,
    job: undefined as any,
    filterValues: {} as any,
    filterLookupValues: {} as any,

    directLoad: false,
    load: false,
    activeDivRef: null as any,

    filterValuesId: null,
    valuesFromDB: false,
    filterVisibleId: null,
    filterVisible: true,
}


export const startReport206202VSkAbstimmung = createAsyncThunk('report206202VSkAbstimmungSlice/startReport206202VSkAbstimmung', async ({ report206202VSkAbstimmung }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.post(
        `/api/ixweb/StartReport206202VSkAbstimmung/`,
        prepareData(report206202VSkAbstimmung),
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { startReport206202VSkAbstimmungStatus } = getState().report206202VSkAbstimmungSlice
        return startReport206202VSkAbstimmungStatus !== 'pending'
    }
})

export const loadUserParamsReport206202VSkAbstimmung = createAsyncThunk('report206202VSkAbstimmungSlice/loadUserParamsReport206202VSkAbstimmung', async (_: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/LoadUserParamsReport206202VSkAbstimmung/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadUserParamsReport206202VSkAbstimmungStatus } = getState().report206202VSkAbstimmungSlice
        return loadUserParamsReport206202VSkAbstimmungStatus !== 'pending'
    }
})

const Report206202VSkAbstimmungSlice = createSlice({
    name: 'report206202VSkAbstimmungSlice',
    initialState,
    reducers: {
        resetstartReport206202VSkAbstimmung: (state) => {
            state.job = undefined
            state.startReport206202VSkAbstimmungError = undefined
        },
        resetstartReport206202VSkAbstimmungError: (state) => {
            state.startReport206202VSkAbstimmungError = undefined
        },
        resetloadUserParamsReport206202VSkAbstimmung: (state) => {
            state.defaultValues = undefined
            state.loadUserParamsReport206202VSkAbstimmungError = undefined
        },
        resetloadUserParamsReport206202VSkAbstimmungError: (state) => {
            state.loadUserParamsReport206202VSkAbstimmungError = undefined
        },
        removeFromReport206202VSkAbstimmungListById: (state, action) => {
            state.report206202VSkAbstimmungList = state.report206202VSkAbstimmungList.filter((x: any) => x.HDR_ID !== action.payload)
        },
        removeFromReport206202VSkAbstimmungListByIds: (state, action) => {
            state.report206202VSkAbstimmungList = state.report206202VSkAbstimmungList.filter((x: any) => action.payload.indexOf(x.HDR_ID) === -1)
        },
        setFilterValues: (state, action) => {
            if (action.payload === undefined || action.payload === null) {
                state.filterValues = {}
            } else {
                state.filterValues = { ...state.filterValues, ...action.payload }
            }
        },
        setFilterLookupValue: (state, action) => {
            const { name, value, formValue } = action.payload
            if (name) {
                state.filterLookupValues[name] = value
                state.filterValues[name] = formValue
            }
        },
        setDirectLoad: (state, action) => { state.directLoad = action.payload },
        setLoad: (state, action) => { state.load = action.payload },
        setActiveDivRef: (state, action) => { state.activeDivRef = action.payload},
        setFilterValuesId: (state, action) => {
            state.filterValuesId = action.payload
        },
        setValuesFromDB: (state, action) => {
            state.valuesFromDB = action.payload
        },
        setFilterVisibleId: (state, action) => {
            state.filterVisibleId = action.payload
        },
        setFilterVisible: (state, action) => {
            state.filterVisible = action.payload
        },
        preloadData: (state, action) => {
            state.report206202VSkAbstimmungList = action.payload.map((x: any) => ({ ...x, HDR_ID: uuid4()}))
            state.startReport206202VSkAbstimmungStatus = 'preloaded'
        },
        clearPreloadedData: (state) => {
            state.report206202VSkAbstimmungList = []
            state.startReport206202VSkAbstimmungStatus = 'idle'
        },
    },
    extraReducers: builder => {
        builder.addCase(startReport206202VSkAbstimmung.pending, (state) => {
            state.startReport206202VSkAbstimmungStatus = 'pending'
            state.startReport206202VSkAbstimmungError = undefined
        })
        builder.addCase(startReport206202VSkAbstimmung.fulfilled, (state, action) => {
            state.startReport206202VSkAbstimmungStatus = 'idle'

            {
                state.job = action.payload

            }
        })
        builder.addCase(startReport206202VSkAbstimmung.rejected, (state, action) => {
            state.startReport206202VSkAbstimmungStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.startReport206202VSkAbstimmungError = action.error.message
            } else {
                state.startReport206202VSkAbstimmungError = action.payload
            }
        })

        builder.addCase(loadUserParamsReport206202VSkAbstimmung.pending, (state) => {
            state.loadUserParamsReport206202VSkAbstimmungStatus = 'pending'
            state.loadUserParamsReport206202VSkAbstimmungError = undefined
        })
        builder.addCase(loadUserParamsReport206202VSkAbstimmung.fulfilled, (state, action) => {
            state.loadUserParamsReport206202VSkAbstimmungStatus = 'idle'

            {
                state.defaultValues = action.payload

            }
        })
        builder.addCase(loadUserParamsReport206202VSkAbstimmung.rejected, (state, action) => {
            state.loadUserParamsReport206202VSkAbstimmungStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadUserParamsReport206202VSkAbstimmungError = action.error.message
            } else {
                state.loadUserParamsReport206202VSkAbstimmungError = action.payload
            }
        })

    }
})

export const {
    resetstartReport206202VSkAbstimmung,
    resetstartReport206202VSkAbstimmungError,
    resetloadUserParamsReport206202VSkAbstimmung,
    resetloadUserParamsReport206202VSkAbstimmungError,
    removeFromReport206202VSkAbstimmungListById,
    removeFromReport206202VSkAbstimmungListByIds,
    setFilterValues,
    setFilterLookupValue,
    setDirectLoad,
    setLoad,
    setActiveDivRef,
    setFilterValuesId,
    setValuesFromDB,
    setFilterVisible,
    setFilterVisibleId,
    preloadData,
    clearPreloadedData,
} = Report206202VSkAbstimmungSlice.actions
export default Report206202VSkAbstimmungSlice.reducer
